import {useMemo} from 'react';
import {PhoneDetails} from '@chekin/core';
import {useFetchLocations} from '@chekin/shared';

export function usePhoneParser() {
  const {phoneCodesAsOptions, isLoadingLocations} = useFetchLocations();

  const parsePhoneNumber = useMemo(() => {
    return (phone: string): PhoneDetails => {
      if (!phone) return {code: '', number: ''};

      const cleanPhone = phone.replace(/\s+/g, '');

      if (cleanPhone.startsWith('+')) {
        const sortedCodes = phoneCodesAsOptions
          .map(option => option.value)
          .sort((a, b) => b.length - a.length);

        for (const code of sortedCodes) {
          if (cleanPhone.startsWith(code)) {
            const number = cleanPhone.substring(code.length);
            if (number.length > 0) {
              return {
                code,
                number,
              };
            }
          }
        }
      }

      return {
        code: '',
        number: phone,
      };
    };
  }, [phoneCodesAsOptions]);

  return {
    parsePhoneNumber,
    phoneCodesAsOptions,
    isLoading: isLoadingLocations,
  };
}
